module.exports = __webpack_public_path__ + "static/media/material-handling-machinery-moving.40ea9bd8.jpg";